import { render, staticRenderFns } from "./TwitterWhite.vue?vue&type=template&id=18b5051f&scoped=true&"
import script from "./TwitterWhite.vue?vue&type=script&lang=js&"
export * from "./TwitterWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5051f",
  null
  
)

export default component.exports